module.exports = __webpack_public_path__ + "img/2_2-industriale-concessionario-0.7192dda2.png";